import React, { useCallback, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import { usePilotContext } from 'src/contexts/pilot.context';
import { actionTypes } from 'src/ducks/pilot.duck';
import { IPilot } from 'src/models/pilot.model';
import Lang from 'src/libraries/language';
import { getPilotStatus } from 'src/selectors/pilot.selector';
import style from '../pilots-list/pilots-list.module.scss';

type IProp = {
  data: IPilot;
};

const PilotsDelete: React.FC<IProp> = ({ data }) => {
  const { state, actions } = usePilotContext();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const deleteStatus = getPilotStatus(state, actionTypes.PILOT_DELETE);

  const handleDelete = useCallback(async () => {
    if (data.pilotId) {
      const response = await actions.itemDELETE(data.pilotId);
      if (!response.error) {
        setIsDeleteOpen(false);
        actions.listGET();

        ToastSuccess(
          Lang.formatString(Lang.MSG_PILOT_DELETE_SUCCESS, data.name)
        );
      } else {
        ToastError(response.error.message);
      }
    }
  }, [actions, data]);

  return (
    <ATMModal
      open={isDeleteOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="trash alternate outline"
          onClick={() => setIsDeleteOpen(true)}
        />
      }
      header={Lang.LBL_DELETE_PILOT}
      content={
        <div className={style.content}>
          {Lang.formatString(
            data.Operators && data.Operators.length > 0
              ? Lang.MSG_CONFIRM_PILOT_OPERATOR_DELETE
              : Lang.MSG_CONFIRM_PILOT_DELETE,
            data.name
          )}
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => setIsDeleteOpen(false)}
          />
          <ATMButton
            negative
            content={Lang.LBL_YES_DELETE}
            onClick={handleDelete}
            disabled={deleteStatus.fetching}
            loading={deleteStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default PilotsDelete;
